import { useEffect, useState } from 'react';

// Componentes
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';

// API
import tipoDeFIscalizacao_api from '../../../../api/tipoDeFIscalizacao_api';

// context 
import { useAuth } from '../../../../context/auth';

// Constants
import { actionsTable } from '../../../../constants/MaterialTable';

// Helpers
import { showMessage } from '../../../../helpers/message';
import ListaInfracoesPorTipoFiscalizacao from './components/ListaInfracoesPorTipoFiscalizacao';

function Infracoes({ permissoes }) {
  //Pegando o estado de controle do loading na tela
  const { setLoading } = useAuth();

  //State para pegar lista dos tipos de fiscalizacao
  const [listTipoDeFiscalizacao, setListTipoDeFiscalizacao] = useState([]);

  //State para pegar o Id do tipo da fiscalização
  const [tipoDeFiscalizacao_Id, setTipoDeFiscalizacao_Id] = useState(null);

  //Variavel de controle de edição da tela
  const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

  //Cabeçalhos da lista de certificados
  const headers = [
    { value: "Identificação", objectValue: "identificacao", align: "left" },
    { value: "Status", objectValue: "status", align: "left" }
  ];

  //Função para visualizar
  const visualizarInfracoesPorTipoFiscalizacao = (rowData) => {
    setTipoDeFiscalizacao_Id(rowData.id);
  }

  //Ações que a tabela terá
  const actions = [actionsTable.visualizar(visualizarInfracoesPorTipoFiscalizacao)];

  const loadTipoDeFiscalizacao = async () => {
    setLoading(true);
    try {
      const response = await tipoDeFIscalizacao_api.getList();
      setListTipoDeFiscalizacao(response.data);
    } catch (err) {
      showMessage("Aviso", "Erro ao buscar lista dos tipos de fiscalização", "error", null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTipoDeFiscalizacao();
  }, []);

  if (!!tipoDeFiscalizacao_Id) {
    return <ListaInfracoesPorTipoFiscalizacao
      handleVoltar={() => {
        setTipoDeFiscalizacao_Id(null);
        loadTipoDeFiscalizacao();
      }}
      editavel={editavel}
      tipofiscalizacao_Id={tipoDeFiscalizacao_Id}
    />
  }

  return <>
    <TabelaListagem
      actions={actions}
      title={"Lista de Tipos de Fiscalização"}
      headers={headers}
      items={listTipoDeFiscalizacao}
    />
  </>
}

export default Infracoes;